export default function Pagination({ itemsPerPage, totalItems, paginate, currentPage }) {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  if (pageNumbers.length <= 1) return null;

  return (
    <nav style={{
      marginTop: '40px',
      display: 'flex',
      justifyContent: 'center',
    }}>
      <ul style={{
        display: 'flex',
        gap: '6px',
        listStyle: 'none',
        padding: '6px',
        borderRadius: '9999px',
        background: 'var(--bg-card)',
        border: '1px solid var(--border-glass)',
      }}>
        {pageNumbers.map(number => (
          <li key={number}>
            <button
              onClick={() => paginate(number)}
              style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.85rem',
                fontWeight: number === currentPage ? 600 : 400,
                fontFamily: 'var(--font-body)',
                transition: 'all 0.25s ease',
                background: number === currentPage
                  ? 'linear-gradient(135deg, var(--accent-cyan), var(--accent-violet))'
                  : 'transparent',
                color: number === currentPage
                  ? '#fff'
                  : 'var(--text-secondary)',
                boxShadow: number === currentPage
                  ? '0 4px 12px rgba(var(--accent-primary-rgb), 0.2)'
                  : 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onMouseEnter={e => {
                if (number !== currentPage) {
                  e.currentTarget.style.background = 'var(--bg-glass)';
                  e.currentTarget.style.color = 'var(--text-primary)';
                }
              }}
              onMouseLeave={e => {
                if (number !== currentPage) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = 'var(--text-secondary)';
                }
              }}
            >
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}